<template>
  <div
    :class="focusClass"
    class="factsheet"
  >
    <dl
      v-if="parent"
      class="factsheet__list"
    >
      <dt
        v-if="parent.columns.location"
        class="factsheet__def"
      >
        Standort
      </dt>
      <dd
        v-if="parent.columns.location"
        class="factsheet__desc"
        v-html="parent.columns.location"
      />
      <dt
        v-if="parent.columns.region"
        class="factsheet__def"
      >
        Wirkungsregion
      </dt>
      <dd
        v-if="parent.columns.region"
        class="factsheet__desc"
        v-html="parent.columns.region"
      />
      <dt
        class="factsheet__def"
      >
        Fokus
      </dt>
      <dd
        v-if="parent.columns.focus"
        class="factsheet__desc"
        v-html="parent.columns.focus"
      />
      <dt
        v-if="parent.columns.projectStarted"
        class="factsheet__def"
      >
        Projektbeginn
      </dt>
      <dd
        v-if="parent.columns.projectStarted"
        class="factsheet__desc"
        v-html="parent.columns.projectStarted"
      />
      <dt
        v-if="parent.columns.location && hasWebsites"
        class="factsheet__def"
      >
        Website
      </dt>
      <dd
        v-if="hasWebsites"
        class="factsheet__desc"
      >
        <div
          v-for="website in websites"
          :key="website.label"
        >
          <a
            :href="website.url"
            class="factsheet__link"
            target="_blank"
          >
            {{ website.label }}
          </a>
        </div>
      </dd>
      <dt
        v-if="parent.columns.partner"
        class="factsheet__def"
      >
        Partner
      </dt>
      <dd
        v-if="parent.columns.partner"
        class="factsheet__desc"
        v-html="parent.columns.partner"
      />
    </dl>
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'

export default {
  name: 'Factsheet',
  mixins: [ editable ],
  data () {
    return {
      focusCmsForm: [
        {
          path: 'metaInformation.focus',
          label: 'Fokus',
          rules: 'required',
          type: 'select',
          items: [
            { text: 'Bildung', value: 'Bildung' },
            { text: 'Gesundheit', value: 'Gesundheit' },
            { text: 'Kultur', value: 'Kultur' },
            { text: 'Sport', value: 'Sport' }
          ]
        }

      ],
      websitesCmsForm: [
        { path: 'metaInformation.website', label: 'Website' }
      ]
    }
  },
  computed: {
    parent () {
      return this.resource.parent
    },
    focusClass () {
      if (!this.parent) {
        return ''
      }
      return this.parent.columns && this.parent.columns.focus ? `factsheet--${this.parent.columns.focus.toLowerCase()}` : null
    },
    websites () {
      if (!this.parent.columns.website) {
        return []
      }
      if (typeof this.parent.columns.website === 'string') {
        return this.parent.columns.website.split(' ')
          .filter(website => website)
          .map(website => ({
            url: website.startsWith('http') ? website : `http://${website}`,
            label: website
          }))
      }
      return this.parent.columns.website
    },
    hasWebsites () {
      return this.websites.length > 0
    }
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/colors';
@import 'beisheim/scss/scale';
@import 'beisheim/scss/font';
@import 'beisheim/scss/grid';
@import 'beisheim/scss/breakpoints';
@import 'beisheim/scss/break-long-words';

.factsheet {
  background-color: gray(3);
  padding-top: scale(8);
  padding-bottom: scale(2);
  @include font(2);

  @include from(4) {
    padding-top: scale(18);
    padding-bottom: scale(14);
  }

  &--bildung {
    background-color: brand(3);
  }
  &--gesundheit {
    background-color: brand(4);
  }
  &--kultur {
    background-color: brand(1);
  }
  &--sport {
    background-color: brand(2);
  }

  &__list {
    @include grid-spacing(padding-left, 3);
    @include grid-spacing(padding-right, 3);
    margin: 0 auto;
    max-width: $max-width;
    width: 100%;

    @include from(4) {
      display: flex;
      flex-wrap: wrap;
      @include grid-spacing(padding-right, 6);
    }
  }

  &__def {
    @include font(0);
    margin-bottom: scale(1);
    @include from(4) {
      @include font(1);
      flex-basis: 35%;
    }
  }

  &__desc {
    margin-bottom: scale(6);
    @include from(4) {
      @include font(1);
      flex-basis: 65%;
      margin-bottom: scale(4);
    }
  }

  &__link {
    @include break-long-words();
    border-bottom: 1px solid gray(1);
  }
}
</style>
